export function convertParamsToString(params) {
    var str = [];
    for (var p in params)
        if (
            params.hasOwnProperty(p) &&
            params[p]
        ) {
            str.push(p + '=' + params[p]);
        }
    if (str.join('&') !== '') {
        return str.join('&');
    }
    return '';
}

export function convertStringToParams(input) {
    if (input === '') return {};
    return JSON.parse('{"' + decodeURIComponent(input.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}')
}

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
